(function stickySearch() {
  (function () {
    $(() => {
      const $searchFake = $('[data-sticky-search-fake]');
      const $searchWrap = $('[data-sticky-search-wrap]');
      const fixedClass = 'sticky-search';

      if (!$searchFake.length) return;

      let offsetPx;
      let isScrolledCached;

      function getIsScrolled() {
        return $(document).scrollTop() > offsetPx;
      }

      function setOffset() {
        offsetPx = $searchFake.offset().top;
      }

      function onScroll() {
        if (isScrolledCached !== getIsScrolled()) {
          isScrolledCached = getIsScrolled();
          $searchWrap.toggleClass(fixedClass, isScrolledCached);
        }
      }

      setOffset();
      onScroll();

      $(window)
        .on('resize', setOffset)
        .on('scroll', onScroll);
    });
  }).call(this);
}());



// WEBPACK FOOTER //
// ./src/scripts/components/sticky-search/index.js